import { Alert, Box, Button, Dialog, DialogContent, TextField, Typography, useTheme } from '@mui/material';
import axios from 'axios';
import { tokens } from '../../../../../theme';
import { useContext } from 'react';
import { UserContext } from '../../../../../context/UserContext';
import { useState } from 'react';
import { useEffect } from 'react';
import AlertDialogSlide from '../../../../../components/AlertDialogSlide';
import { Formik } from 'formik';
import * as yup from "yup";
import BrandLegalInfoDialog from '../../../../../components/BrandLegalInfoDialog';

function PurchasableProductsDialog({ targetAd, open, handleClose }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { token } = useContext(UserContext);

    console.log("targetAd in PurchasableProductsDialog:", targetAd);

    const [purchasableProducts, setPurchasableProducts] = useState([]);
    const [targetProductToUpdate, setTargetProductToUpdate] = useState(null);
    const [targetProductToDelete, setTargetProductToDelete] = useState(null);
    const [purchasableProductDialogOpen, setPurchasableProductDialogOpen] = useState(false);
    const [isLegalInfoDialogOpen, setIsLegalInfoDialogOpen] = useState(targetAd.brand_legal_name ? false : true);

    const fetchPurchasableProducts = () => {
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getPurchasableProducts?token=${token}&adId=${targetAd.id}`)
            .catch((err) => {
                console.log("err: " + err);
                setPurchasableProducts((prev) => []);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setPurchasableProducts(response.data.products);
                }
            });
    }

    const createPurchasableProduct = (product) => {

        axios.post(`${process.env.REACT_APP_API_URL}api/alcago/ad/createPurchasableProduct?token=${token}`, {
            ...product,
            ad_id: targetAd.id
        })
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    fetchPurchasableProducts();
                    setPurchasableProductDialogOpen(false);
                }
            });
    };

    const updatePurchasableProduct = (productId, updatedData) => {
        axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/ad/updatePurchasableProduct?token=${token}&productId=${productId}`, updatedData)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    fetchPurchasableProducts();
                    setTargetProductToUpdate(null);
                    setPurchasableProductDialogOpen(false);
                }
            });
    };

    const removePurchasableProduct = (product) => {
        axios.delete(`${process.env.REACT_APP_API_URL}api/alcago/ad/deletePurchasableProduct?token=${token}&productId=${product.id}`)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    setTargetProductToDelete(null);
                    fetchPurchasableProducts();
                }
            });
    };

    useEffect(() => {
        fetchPurchasableProducts();
    }, []);

    useEffect(() => {
        if (targetProductToUpdate) {
            setPurchasableProductDialogOpen(true);
        }
    }, [targetProductToUpdate]);

    return (
        <Dialog
            sx={{ margin: "0 auto" }} open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="md">
            <BrandLegalInfoDialog
                brandId={targetAd.brand_id}
                open={isLegalInfoDialogOpen}
                handleClose={() => { setIsLegalInfoDialogOpen(false); handleClose(); }}
                onUpdate={() => { setIsLegalInfoDialogOpen(false); }}
            />
            <AlertDialogSlide
                open={targetProductToDelete !== null}
                handleClose={() => {
                    setTargetProductToDelete(null);
                }}
                clickNegativeAnswer={() => {
                    setTargetProductToDelete(null);
                }}
                clickPositiveAnswer={() => {
                    if (targetProductToDelete) {
                        removePurchasableProduct(targetProductToDelete);
                    }
                }}
                title="Ürünü Kaldır"
                description="Bu satın alınabilir ürünü kaldırmak istediğinize emin misiniz?"
                positiveAnswer="Evet"
                negativeAnswer="Hayır"
            />
            <Dialog
                sx={{ margin: "0 auto" }}
                open={purchasableProductDialogOpen}
                onClose={() => {
                    setTargetProductToUpdate(null);
                    setPurchasableProductDialogOpen(false)
                }}
                fullWidth
                maxWidth="md">
                <Box minWidth="300px" m="20px" textAlign="center">
                    <Typography variant='h3'>
                        {targetProductToUpdate ? "Ürünü Düzenle" : "Ürün Ekle"}
                    </Typography>
                </Box>
                <DialogContent>
                    <Box display="flex" justifyContent="center" flexWrap={"wrap"}>
                        <Formik
                            onSubmit={(values) => {
                                if (targetProductToUpdate) {
                                    updatePurchasableProduct(targetProductToUpdate.id, values);
                                } else {
                                    createPurchasableProduct(values);
                                }
                            }}
                            initialValues={targetProductToUpdate ? {
                                name: targetProductToUpdate.name,
                                price_tl: targetProductToUpdate.price_tl
                            } : {
                                name: "",
                                price_tl: 1
                            }}
                            validationSchema={yup.object().shape({
                                name: yup.string().max(250, "En fazla 250 karakter olabilir").required("zorunlu"),
                                price_tl: yup.number().min(1, "Geçersiz fiyat").required("zorunlu"),
                            })}
                        >
                            {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                                <form onSubmit={handleSubmit}>
                                    <Box display="grid" gap="15px" gridTemplateColumns="repeat(2, minmax(0, 1fr))" mx="75px" mb="25px">
                                        <TextField
                                            fullWidth
                                            variant="filled"
                                            type="text"
                                            label="Ürün Adı"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.name}
                                            name="name"
                                            error={!!touched.name && !!errors.name}
                                            helperText={touched.name && errors.name}
                                            sx={{ gridColumn: "span 2" }}
                                        />
                                        <TextField
                                            fullWidth
                                            variant="filled"
                                            type="number"
                                            label="İndirimsiz Fiyat (₺)"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.price_tl}
                                            name="price_tl"
                                            error={!!touched.price_tl && !!errors.price_tl}
                                            helperText={touched.price_tl && errors.price_tl}
                                            sx={{ gridColumn: "span 1" }}
                                        />
                                    </Box>
                                    <Box display="flex" justifyContent="center" m="20px 20px 0px 20px">
                                        <Button type="submit" color="secondary" variant="contained">
                                            <Typography variant='h5'>Kaydet</Typography>
                                        </Button>
                                    </Box>
                                </form>
                            )}
                        </Formik>
                    </Box>
                </DialogContent>
            </Dialog>

            <Box minWidth="300px" m="20px" textAlign="center">
                <Typography variant='h3'>
                    Satın Alınabilir Ürünler
                </Typography>
            </Box>
            <DialogContent>
                <Box mt="10px">
                    {purchasableProducts.length === 0 &&
                        <Alert severity="info">
                            Satın alınabilir ürün bulunmamaktadır.
                        </Alert>}
                    <Box display="flex" flexDirection={"column"}>
                        {purchasableProducts.map((product) =>
                            <Box key={product.id}
                                // width="60%"
                                m="10px"
                                p={"10px"}
                                sx={{
                                    background: colors.primary[600],
                                    border: "1px solid " + colors.primary[200],
                                    borderRadius: "20px",
                                }}>

                                <Box>
                                    <Typography variant='h3' color={colors.grey[100]}>{product.name}</Typography>
                                    <Typography variant='h5' color={colors.primary[200]}>
                                        <span style={{ textDecoration: "line-through", marginRight: "10px" }}>
                                            {product.price_tl.toFixed(2)}₺
                                        </span>
                                        {(product.price_tl * (100 - targetAd.discount_percentage) / 100).toFixed(2)}₺
                                    </Typography>
                                </Box>
                                <Box mt="10px" display="flex" justifyContent="end" alignItems="center" gap="10px" px="5px">
                                    <Button variant='outlined' color='info' onClick={() => {
                                        setTargetProductToUpdate(product);
                                    }}
                                        sx={{
                                            height: "35px",
                                            borderColor: colors.blueAccent[600],
                                            color: colors.blueAccent[600]
                                        }}>
                                        Düzenle
                                    </Button>
                                    <Button variant='outlined' color='warning' onClick={() => {
                                        setTargetProductToDelete(product);
                                    }}
                                        sx={{
                                            height: "35px",
                                            borderColor: colors.redAccent[700],
                                            color: colors.redAccent[700]
                                        }}>
                                        Kaldır
                                    </Button>
                                </Box>

                            </Box>
                        )}
                    </Box>
                    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" rowGap="10px" mt="20px">
                        <Button onClick={() => setPurchasableProductDialogOpen(true)} variant="contained" color="success">Ürün Ekle</Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default PurchasableProductsDialog;